<template>
    <div class='navbar'>
        <van-nav-bar @click-left="onClickLeft">
            <template #right>
                <slot name="right"></slot>
            </template>
            <template #left>
                <slot name="left"></slot>
            </template>
            <template #title>
                <slot name="title"></slot>
            </template>
        </van-nav-bar>
    </div>
</template>
<script>
export default {
    data() {
        return {}
    },
    mounted() {

    },
    computed: {},
    methods: {
        onClickLeft() {
            this.$router.go(-1)
        }
    },
}
</script>
<style lang='less' scoped>
.navbar {
    height: 1.44rem;

    ::v-deep {
        .van-nav-bar {
            height: 100%;

            .van-nav-bar__content {
                height: 100%;
            }
        }

        .van-hairline--bottom::after {
            border-width: 0;
        }
    }
}
</style>
